<template>
  <div class="c-home-wrapper">
    <!-- <div class="banner">
      <img :src="banner" />
    </div> -->

    <el-carousel class="index-swiper">
      <el-carousel-item v-for="(item, index) in images" :key="index">
        <img :src="item.WebSite" />
      </el-carousel-item>
    </el-carousel>

    <div class="news">
      <div class="news-img-wrap">
        <img :src="indexBody.WebSite" alt="" />
      </div>
      <div class="news-content">
        <div class="con" v-html="formatBody(indexBody)"></div>
        <el-button type="primary" @click="$router.push('/about-us')">{{
          $t("other.readMore")
        }}</el-button>
      </div>
    </div>

    <div class="product-category">
      <h1>{{ $t("title.oneDream") }}</h1>
      <Swiper :swiperData="swiperData" />
    </div>

    <div class="guest-department">
      <h1>{{ $t("title.guestDepartment") }}</h1>
      <div class="img-wrap">
        <img :src="guestDepartment.WebSite" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
// import ProductCategorySwiper from "@/components/pc/ProductCategorySwiper/ProductCategorySwiper.vue";
import Swiper from "@/components/pc/Carousel/Carousel.vue";
export default {
  components: {
    // ProductCategorySwiper
    Swiper
  },
  data() {
    return {
      images: [],
      indexBody: {},
      swiperData: [],
      guestDepartment: {},
      swiperOption: {
        pagination: {
          el: ".swiper-pagination"
        }
      }
    };
  },

  mounted() {
    this.$store.dispatch("getIndexBanner").then(res => {
      this.images = res.Data;
    });
    const indexBodyParams = {
      Data: {
        FInterID: 1
      }
    };
    this.$store.dispatch("getIndexBodyData", indexBodyParams).then(res => {
      this.indexBody = res.Data;
    });

    // 轮播
    this.$store.dispatch("getIndexSwiperData").then(res => {
      this.swiperData = res.Data;
    });

    // 客户分布
    const guestDepartmentParams = {
      Data: {
        FInterID: 2
      }
    };
    this.$store
      .dispatch("getIndexBodyData", guestDepartmentParams)
      .then(res => {
        this.guestDepartment = res.Data;
      });
  },
  methods: {
    formatBody() {
      let body;
      if (this.$i18n.locale === "zh") {
        body = this.indexBody.Body;
      } else if (this.$i18n.locale === "en") {
        body = this.indexBody.EnglishBody;
      } else if (this.$i18n.locale === "sp") {
        body = this.indexBody.xibanyaBody;
      }
      return body;
    }
  }
};
</script>

<style lang="less">
.c-home-wrapper {
  // .banner {
  //   width: 100%;
  //   height: 1200px;

  //   img {
  //     display: block;
  //     width: 100%;
  //     height: 100%;
  //   }
  // }

  .index-swiper {
    width: 100%;
    height: 1200px;

    .el-carousel__container {
      width: 100%;
      height: 100%;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }

  .news {
    width: 1200px;
    min-height: 592px;
    background: rgba(255, 255, 255, 1);
    display: flex;
    align-items: center;
    position: relative;
    top: -95px;
    left: 50%;
    transform: translateX(-50%);
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.3);
    z-index: 2001;
    background: url("../../../../assets/imgs/c-index-news-bg.png") top center
      no-repeat;
    background-size: 100% 100%;

    .news-img-wrap {
      width: 600px;
      height: 450px;
      margin-right: 130px;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .news-content {
      flex: 1;
      text-align: left;
      padding-right: 40px;

      .con {
        line-height: 21px;
        margin-bottom: 60px;
      }

      button {
        width: 166px;
        height: 56px;
        background: rgba(0, 100, 178, 1);
        border-radius: 2px;
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 56px;
        color: rgba(255, 255, 255, 1);
        padding: 0;
      }
    }
  }

  .product-category {
    width: 100%;
    min-height: 920px;
    background: url("../../../../assets/imgs/c-product-category-bg.png") top
      center no-repeat;
    background-size: 100% 100%;
    padding: 48px 0;

    h1 {
      font-size: 48px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(0, 0, 0, 1);
      margin-bottom: 100px;
    }
  }

  .guest-department {
    width: 100%;
    padding: 48px 0;

    h1 {
      font-size: 48px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(0, 0, 0, 1);
      margin-bottom: 74px;
    }

    .img-wrap {
      width: 1200px;
      height: 502px;
      margin: 0 auto;
    }
  }
}
</style>
